<div
  class="popup-dialog"
  [class.popup-dialog--estimated-quote-revision]="
    data.title === 'Estimated Quote Revision'
  "
  [class.popup-dialog--center-content]="data.centerContent"
  role="dialog"
  [attr.data-testid]="data.dialogTestId ?? null"
  [attr.aria-label]="data.title"
  cdkTrapFocus
  cdkTrapFocusAutoCapture
>
  <div class="popup-header">
    <h2 class="popup-title" data-testid="popup-header-title">{{ data.title }}</h2>
    @if (!frozen()) {
      <button
        type="button"
        class="popup-close"
        aria-label="Close dialog"
        data-testid="popup-close-btn"
        (click)="onCloseX()"
      >
        <mat-icon class="popup-close-icon" aria-hidden="true">close</mat-icon>
      </button>
    }
  </div>

  <div
    class="popup-body"
    [class.no-buttons]="data.hideButtons"
    [class.center-content-mode]="data.centerContent"
  >
    <!-- Dynamic component host -->
    <ng-container #contentHost />

    <!-- Simple message content -->
    @if (data.message || data.headline) {
      <div [class.center]="data.centerContent">
        @if (data.showSpinner) {
          <app-spinner
            [display]="true"
            [class]="'popup-spinner-container'"
            [diameter]="88"
          ></app-spinner>
        }
        @if (data.icon) {
          <span class="popup-icon-container">
            <mat-icon [class]="data.icon.cssClass ?? ''" aria-hidden="true">{{ data.icon.name }}</mat-icon>
          </span>
        }
        @if (data.headline) {
          <span class="popup-headline">{{ data.headline }}</span>
        }
        @if (data.message) {
          <p class="popup-message" [innerHTML]="data.message"></p>
        }
      </div>
    }
  </div>

  @if (!data.hideButtons) {
    <div class="popup-footer">
      <button
        type="button"
        class="clear"
        [attr.data-testid]="data.cancelButtonTestId ?? null"
        [disabled]="frozen()"
        (click)="onCancel()"
        data-testid="popup-cancel-btn"
      >
        {{ data.cancelLabel ?? "Cancel" }}
      </button>
      <button
        type="button"
        class="primary"
        [attr.data-testid]="data.confirmButtonTestId ?? null"
        [disabled]="frozen()"
        (click)="onConfirm()"
        data-testid="popup-confirm-btn"
      >
        {{ data.confirmLabel ?? "Confirm" }}
      </button>
    </div>
  }
</div>
